import { createContext } from 'react';

const variableModeloContext = createContext();

export default variableModeloContext;